import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import classes from "./Dashboard.module.scss";
import LoadingDots from "../components/UI/LoadingDots";
import useDashboardData from "../hooks/useDashboardData";
import DashboardDisplay from "../components/dashboardComponents/DashboardDisplay";
import DashboardPlaceholder from "../components/dashboardComponents/DashboardPlaceholder";
import { OrgIdContext, ClientTypes } from "../store/orgId_context";

const Dashboard = () => {
  const {clientType} = useContext(OrgIdContext);
  const { isLoading, data: currentTData, clients } = useDashboardData(5);
  //console.log(clientType);
  return (
    <>
      <Helmet>
        <title>Dashboard | DDD Invoices</title>
      </Helmet>
      {isLoading && false && <DashboardPlaceholder/>}
      {isLoading && false && (
        <LoadingDots className="w-100 h-100 d-flex align-items-center justify-content-center" />
      )}
      <DashboardDisplay currentTData={currentTData} clients={clients} isLoading={isLoading} />
      {/*!isLoading &&
        (currentTData ? (
          <DashboardDisplay currentTData={currentTData} clients={clients} />
        ) : (
          <div
            className={`w-100 p-5 d-flex justify-content-center align-items-center ${classes.container}`}
          >
            <p>An error has occured.</p>
          </div>
        ))*/}
    </>
  );
};

export default Dashboard;
